/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum EngagementLength {
  ZeroToThree = "0-3",
  FourToSix = "4-6",
  SevenToNine = "7-9",
  TenToTwelve = "10-12",
  TwelvePlus = "12+",
}

export const EngagementLengthDisplay: Record<EngagementLength, string> = {
  [EngagementLength.ZeroToThree]: "0-3",
  [EngagementLength.FourToSix]: "4-6",
  [EngagementLength.SevenToNine]: "7-9",
  [EngagementLength.TenToTwelve]: "10-12",
  [EngagementLength.TwelvePlus]: "12+",
};
